var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M364.032 125.312a293.973 293.973 0 0 1 300.117 2.475c91.478 56.832 147.03 158.293 146.518 267.306-2.134 108.374-61.739 210.304-136.235 289.067a798.976 798.976 0 0 1-143.275 120.32 50.09 50.09 0 0 1-17.45 6.187 34.987 34.987 0 0 1-16.64-5.078 789.973 789.973 0 0 1-206.464-194.005 395.947 395.947 0 0 1-77.27-221.867l.214-11.648c3.84-104.789 60.586-200.533 150.485-252.757zM550.699 300.16a100.096 100.096 0 0 0-110.678 22.187 104.747 104.747 0 0 0-22.144 112.64 101.461 101.461 0 0 0 93.782 63.872 99.797 99.797 0 0 0 71.808-29.952c19.029-19.328 29.696-45.654 29.61-73.046A103.381 103.381 0 0 0 550.7 300.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#200E32",
    d: "M298.667 896a213.333 42.667 0 1 0 426.666 0 213.333 42.667 0 1 0-426.666 0z",
    opacity: 0.4
  })));
};
export default SvgLocation;